import { Centrifuge } from "centrifuge";

/**
 * Подключение и обработка real time сообщений от сервера. Использует библиотеку Centrifuge.
 * @class
 * @property {Centrifuge} centrifuge Экземпляр Centrifuge
 * @property {string} user Идентификатор пользователя для подписки на приватные каналы
 */
class RealTime {
  /**
   * @constructor
   * @param {string} url Урл для подключения centrifuge
   * @param {string} token Токен для инициализации centrifuge
   * @param {string} user Идентификатор пользователя для подписки на приватные каналы
   */
  constructor(url, token, user) {
    this.centrifuge = new Centrifuge(url, {token: token});
    this.centrifuge.connect();
    this.user = user;
  }

  /**
   * Прямая подписка на получение сообщений из канала
   * @param {string} channel Название канала
   * @param {Function} callback Обработчик сообщений
   */
  subscribe(channel, callback) {
    this.sub = this.centrifuge.newSubscription(channel, message => callback(message.data));
  }

  /**
   * Подписка на получение сообщений из приватного канала
   * @param {string} channel Название канала без префиксов и постфиксов
   * @param {Function} callback Обработчик сообщений
   */
  subscribePrivate(channel, callback) {
    if (!this.user) return false;
    this.subscribe(`${channel}#${this.user}`, callback);
  }

  /**
   * Подписка на получение сообщений из публичного канала
   * @param {string} channel Название канала без префиксов и постфиксов
   * @param {Function} callback Обработчик сообщений
   */
  subscribePublic(channel, callback) {
    this.subscribe(`public:${channel}`, callback);
  }

  /**
   * Публикация в канал
   * @param {string} channel Название канала
   * @param {*} data Данные для публикации
   * @returns {Promise<*>}
   */
  publish(channel, data) {
    return this.centrifuge.publish(channel + "#" + user, data);
  }
}

export { RealTime };